import { render, staticRenderFns } from "./iformationEdit.vue?vue&type=template&id=724c3aef&scoped=true&"
import script from "./iformationEdit.vue?vue&type=script&lang=js&"
export * from "./iformationEdit.vue?vue&type=script&lang=js&"
import style0 from "./iformationEdit.vue?vue&type=style&index=0&id=724c3aef&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724c3aef",
  null
  
)

export default component.exports